export default __webpack_public_path__ + "static/about-6908b5ef7598deac70b59be4362f84a6.jpg";